import { useContext } from "react";
import { ISurveyContext, SurveyContext } from "../providers/SurveyProvider";

export const useSurvey = (): ISurveyContext => {
  const context = useContext(SurveyContext);
  if (context === undefined) {
    throw new Error("useSurvey must be used within a SurveyProvider");
  }
  return context;
};
